"use client"
import { useState } from "react"



const ListProducts = ({PromoProduct}) => {
    const [focus,setFocus]= useState(0)
    
    // Ensure promotionImages is an array and has items
    const promotionImages = PromoProduct?.promotionImages || [];
    const hasImages = Array.isArray(promotionImages) && promotionImages.length > 0;
    
    if (!hasImages) {
        return null; // Don't render if no images
    }
    
    return(
        <div className="hidden lg:flex">
            {
                promotionImages.map((el,index)=>{
                    // Handle different data types - el might be a string, array, or other type
                    let imageUrl = '';
                    if (typeof el === 'string') {
                        imageUrl = el.trim();
                    } else if (Array.isArray(el)) {
                        // If it's an array, find the first string value
                        const url = el.find(url => url && typeof url === 'string');
                        imageUrl = url ? url.trim() : '';
                    } else if (el) {
                        // Try to convert to string
                        imageUrl = String(el).trim();
                    }
                    
                    // Skip empty or invalid images
                    if (!imageUrl || imageUrl === '') return null;
                    
                    return(
                        <div
                    key={index}
                    className={`relative w-[19%] h-[290px] transition-all duration-300 ease-in-out cursor-pointer 
                    ${index === focus ? "border-4  w-[24%] scale-105" : ""}`}
                    onClick={() => setFocus(index)}
                >
                    <img 
                        src={imageUrl} 
                        alt={`Product ${index + 1}`} 
                        className="w-full h-full object-cover rounded-lg transition-all duration-300 hover:scale-150"
                        onError={(e) => {
                            console.error('Failed to load promotion image:', imageUrl);
                            e.target.style.display = 'none';
                        }}
                    />
                </div>   
                    )
                })
            }
        </div>
    )
}

export default ListProducts